// extracted by mini-css-extract-plugin
export var label = "_ab-1";
export var reminder = "_ab-0";